<template>
        <div class="hslp-purchase">
            <page-loader :loading="inProcess"></page-loader>
        <!--step6- 2 Year Protection-->
            <div id="product-purchase" v-if="payNow==true">
                <div class="product-purchase-box">
                    <div class="text-center">
                        <b-img  v-if="selectedPayment==2" class="popular-image" :src="require('@assets/images/v3/Generic House.svg')" alt="" />
                        <b-img v-else class="popular-image" :src="require('@assets/images/v3/Protection-3 Year.svg')" alt="" />
                    </div>
                    <h2>Your Protection</h2>
                    <h3>Home Sale Legal Protection - {{ selectedPayment }} Years
                        <span class="float-end">{{ price | currency('$', 0) }}</span>
                    </h3>
                    <p class="grey">{{ selectedPayment }} years and ${{hours}} of legal protection.</p>
                    <p class="grey mb-0">By clicking the pay button below, you authorize Sellers Shield to
                        charge this card for your Home Sale Legal Protection. </p>

                    <h2>Payment Details</h2>
                    <h4><i class="fa-sharp fa-regular fa-credit-card"></i>Add your billing information.
                    </h4>

                    <form>
                        <div class="row">
                            <div class="col-12 form-group">
                                <label class="form-label">Card Number</label>
                                <div class="form-control" id="card-number" ref="cardNumber"></div>
                                <b-img :src="require('@assets/images/v3/creditCardBrands.png')" alt="" />
                            </div>
                            <div class="col-sm-6 col-12 mt-1 form-group">
                                <label class="form-label">Expiration Date</label>
                                <div class="form-control" id="card-expiry" ref="cardExpiry"></div>
                            </div>
                            <div class="col-sm-6 col-12 mt-1 form-group">
                                <label class="form-label">CVC</label>
                                <div  class="form-control" id="card-cvc" ref="cardCvc"></div>
                                <b-img :src="require('@assets/images/v3/creditCardCvc.svg')" alt="" />
                            </div>
                            <div class="col-sm-6 col-12 mt-1 form-group">
                                <label class="form-label">Country</label>
                                <div class="form-control">
                                    <CountrySelect v-model="country" :country="country" topCountry="US" />
                                </div>                        
                            </div>
                            <div class="col-sm-6 col-12 mt-1 form-group">
                                <label class="form-label">Zip</label>
                                <b-input type="text" class="form-control" v-model="zip"
                                    placeholder="12345" />
                            </div>
                            <div class="col-sm-12 col-12 mt-1" id="stripe-error" v-if="error">
                                <b-alert show dismissible variant="danger">
                                    {{ error }}
                                </b-alert>
                            </div>
                            <div class="col-12 text-center">
                                <button @click.prevent="sendPayment()" class="btn btn-secondary">Pay ${{price}} and Sign Forms</button>
                            </div>
                            <div class="col-12 text-center">
                                <button class="btn btn-link" v-on:click.prevent="cancelPayment()">Cancel</button>
                            </div>
                        </div>
                    </form>
                    

                </div>
            </div>
        <!--step6- 2 Year Protection-->
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import StripeService from '@services/stripe.service';
import vueCountryRegionSelect from 'vue-country-region-select'
import axios from 'axios';
import { usePaymentStore } from '@store';
import './HslpPurchase.scss';
import PageLoader from '@components/loaders/PageLoader/PageLoader.vue';

const store = usePaymentStore()

export default {
    name: 'HslpPurchase',
    mixins: [
    ],
    components:{
        CountrySelect: vueCountryRegionSelect.CountrySelect,
        PageLoader,
    },
    props: {
        selectedPayment: {
            type: Number,
            default: 2,
        },
        price: {
            type: Number
        },
        hours: {
            type: Number
        },
        orderAppResource: {
            type:Object
        },
        tierValue: {
            type: String,
            default: '2',
        },
        state_id: {
            type: Number,
        },
        payNow: {
            type: Boolean,
        },
        vwoTesting:{
            type: Boolean,
        }
    },
    data(){
        return { 
            stripe: Stripe(window.env.STRIPE_PUBLISHABLE_KEY),
            elements: null,
            clientSecret: null,
            zip:null,
            card: {
                cardNumber:null,
                cardCvc: null,
                cardExpiry: null,
            },
            country:'',
            error: '',
            processing: false
        }
    },
    computed: {
        inProcess(){
            return this.processing;
        }
    },
    mounted(){
        const fieldStyleConfig = {
            style: {
                base: {
                    '::placeholder': {
                        color: '#292b2d'
                    },
                    backgroundColor: '#f4f4f4',
                    fontSize: '16px'
                }
            }
        };
        this.createIntent();
        this.elements = this.stripe.elements();
        const cardNumberElement = this.elements.create('cardNumber', fieldStyleConfig);
        cardNumberElement.mount(this.$refs.cardNumber);

        const cardExpiryElement = this.elements.create('cardExpiry', fieldStyleConfig);
        cardExpiryElement.mount(this.$refs.cardExpiry);

        const cardCvcElement = this.elements.create('cardCvc', fieldStyleConfig);
        cardCvcElement.mount(this.$refs.cardCvc);

        this.card.cardNumber = cardNumberElement;
        this.card.cardExpiry = cardExpiryElement;
        this.card.cardCvc = cardCvcElement; 
    },
    methods:{
        async createIntent(){
            let stripeResponse = await axios.post(`${window.env.MILESTONES_API_HOST}/api/v1/stripe/get-secret`, {
                state_id: this.state_id,
                tier:`Price_pay_now_tier_${this.tierValue}_seller`,
                price: this.vwoTesting ? this.price : null
            });
            this.clientSecret = stripeResponse.data.client_secret;
        },
        async sendPayment() {
            this.processing = true;
            this.error='';
            const {
                  paymentIntent,
                  error: confirmError,
                } = await this.stripe.confirmCardPayment(
                  this.clientSecret,{
                    payment_method: {
                    card: this.card.cardNumber,
                    billing_details: {
                        address: {
                            postal_code: this.zip,
                            country: this.country
                        }
                    }
                }}
                );
            if(confirmError){
                this.error=confirmError.message
            }
            else{
                if(paymentIntent.status=="succeeded")
                    store.completed = true;
                    this.$emit('save-hslp', this.orderAppResource);
            }
            this.processing = false;
        },
        cancelPayment() {
            this.$emit('cancel-payment');
        }
    },
    async created() {
    }
}
</script>

<style scoped>
    .product-purchase-box .StripeElement--invalid {
        box-shadow: 0 0 3px rgb(255 0 0 / 50%) !important;
    }

    .form-label {
        margin-bottom: 0;
        color: #292b2d !important;
    }

    .product-purchase-box .form-control::placeholder {
        color: #292b2d !important;
    }

    #card-number div {
        top: 3px !important;
    }

    .form-group .form-control, .form-group .form-control select {
        background-color: #f4f4f4 !important;
    }

    .alert {
        font-size: 16px;
        color: #a22c33;
        background: #f4cbcd;
    }
</style>